import { connect } from 'react-redux'

import Modal from './modal'
import ModalActions from '../../Redux/ModalRedux'

export const mapStateToProps = state => ({
  isOpen: state.modal.isOpen,
  type: state.modal.type,
  modalProps: state.modal.modalProps
})

export const mapDispatchToProps = dispatch => ({
  modalClose: () => dispatch(ModalActions.modalClose()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
